// Module
var code = "<modal title=\"{{ 'Save filter' | translate }}\" cancel=$hide() save=$ctrl.save()> <label for=filter-name translate>Filter name</label> <input ng-model=$ctrl.name id=filter-name class=form-control pattern=[a-zA-Z0-9\\s]+ autofocus required/> </modal> ";
// Exports
module.exports = code;